<template>
  <v-main>
    <AppBar />
    <v-container class="pt-0">
      <ul class="list-group ps-0">
        <li v-for="(item,i) in title" :key="i" @click="tutorialSelect(i)">{{title[i]}}</li>
      </ul>
      <TutorialDetailsModal :dialog="dialog" @close="dialog = false" :select="select"/>
    </v-container>
  </v-main>
</template>
<script>
import TutorialDetailsModal from "@/components/tutorial/TutorialDetailsModal";
export default {
    data: () => ({
        dialog:false,
        select:0,
        title:['메인','도서관','광장','여행가방','마음 날씨','마음 노트','찐한 대화'],
    }),
    components:{
        TutorialDetailsModal,
    },
    methods:{
        tutorialSelect(num){
            this.select = num;
            this.dialog = true;
        }
    }
}
</script>
